import { render, staticRenderFns } from "./ExpelledAcademicVacationView.vue?vue&type=template&id=53e5ca50"
import script from "./ExpelledAcademicVacationView.vue?vue&type=script&lang=js"
export * from "./ExpelledAcademicVacationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports